const defaults = {
  pagination: {
    perPage: 10,
    perPageChoice: [10, 25, 50, 75, 100],
  },
  bigLimit: 500,
};

export default defaults;
